export const SSN_MAX_LENGTH = 11;

export const formatSSN = (text: string): string => {
  let formattedText = text.replace(/\D/g, '');
  if (formattedText.length > 3 && formattedText.length <= 5) {
    formattedText = `${formattedText.slice(0, 3)}-${formattedText.slice(3)}`;
  } else if (formattedText.length > 5) {
    formattedText = `${formattedText.slice(0, 3)}-${formattedText.slice(3, 5)}-${formattedText.slice(5, 9)}`;
  }
  return formattedText;
};
